export const SET_STATISTIC = 'SET_STATISTIC';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_COUNT_TASKS = 'SET_COUNT_TASKS';
export const SET_FAREWELL = 'SET_FAREWELL';

export function setStatistic(data) {return{type: SET_STATISTIC, payload: data}}
export function setUserData(data) {return{type: SET_USER_DATA, payload: data}}
export function setCountTasks(data) {return{type: SET_COUNT_TASKS, payload: data}}
export function setFarewell(data) {return{type: SET_FAREWELL, payload: data}}
